import BaseDatePicker from 'react-date-picker';
import DateTimePicker from 'react-datetime-picker';

import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import DateTimeRangePicker from '@wojtekmaj/react-datetimerange-picker';

export const getPickerComponent = ({ isTime, isRange, isTimeRange, isTimezone }) => {
  if ((isTime || isTimeRange) && !isTimezone)
    throw new Error('isTimezone must be true when isTime or isTimeRange is true.');

  if ((isTime && isTimeRange) || (isRange && isTimeRange) || (isTime && isRange))
    throw new Error('isTime, isRange or isTimeRange cannot be true at the same time.');

  if (isTime) return DateTimePicker;
  if (isRange) return DateRangePicker;
  if (isTimeRange) return DateTimeRangePicker;
  return BaseDatePicker;
};
